export default class FoulingLogData {
    constructor(
        id,
        vessel,
        date,
        location,
        serviceProvider,
        report,
        entryType,
        operatingArea,
        pp,
        hc,
        hullInsp,
        dd,
        phcl,
        notes,
        avgSailingSpeedKnots,
        idleDaysPortAnchorAvgMonthlyDaysSinceLastActivity,
        cleaningMethod,
        prSlime,
        prGrowth,
        prShellsAnimalsEtc,
        prDamageToBlades,
        boottopSlime,
        boottopGrowth,
        boottopShellsAnimalsEtc,
        boottopDamageToPaint,
        vsSlime,
        vsGrowth,
        vsShellsAnimalsEtc,
        vsDamageToPaint,
        fbSlime,
        fbGrowth,
        fbShellsAnimalsEtc,
        fbDamageToPaint,
        vesselId,
        dateOfCalculation
    ) {
        this.id = id;
        this.vessel = vessel;
        this.date = date;
        this.location = location;
        this.serviceProvider = serviceProvider;
        this.report = report;
        this.entryType = entryType;
        this.operatingArea = operatingArea;
        this.pp = pp;
        this.hc = hc;
        this.hullInsp = hullInsp;
        this.dd = dd;
        this.phcl = phcl;
        this.notes = notes;
        this.avgSailingSpeedKnots = avgSailingSpeedKnots;
        this.idleDaysPortAnchorAvgMonthlyDaysSinceLastActivity = idleDaysPortAnchorAvgMonthlyDaysSinceLastActivity;
        this.cleaningMethod = cleaningMethod;
        this.prSlime = prSlime;
        this.prGrowth = prGrowth;
        this.prShellsAnimalsEtc = prShellsAnimalsEtc;
        this.prDamageToBlades = prDamageToBlades;
        this.boottopSlime = boottopSlime;
        this.boottopGrowth = boottopGrowth;
        this.boottopShellsAnimalsEtc = boottopShellsAnimalsEtc;
        this.boottopDamageToPaint = boottopDamageToPaint;
        this.vsSlime = vsSlime;
        this.vsGrowth = vsGrowth;
        this.vsShellsAnimalsEtc = vsShellsAnimalsEtc;
        this.vsDamageToPaint = vsDamageToPaint;
        this.fbSlime = fbSlime;
        this.fbGrowth = fbGrowth;
        this.fbShellsAnimalsEtc = fbShellsAnimalsEtc;
        this.fbDamageToPaint = fbDamageToPaint;
        this.vesselId = vesselId;
        this.dateOfCalculation = dateOfCalculation;
    }
} 